import Link from 'next/link'

import { useBranding } from '@/hooks/use-branding'
import useLocale from '@/hooks/use-locale'
import useMediaQuery from '@/hooks/use-media-query'

import { Button } from '@/components/ui/button'

import { FORM_REGISTER_URL } from '@/constant/app'

export default function DefaultNavRightContent() {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const { isFsdsDomain } = useBranding()
  const { text } = useLocale()

  return (
    <div className="ml-auto flex gap-2">
      <Button asChild size="lg" className="px-0 text-base sm:px-4" variant="link">
        <Link href="/sign-in">{text.HEADER.LOGIN}</Link>
      </Button>
      {!isMobile && isFsdsDomain && (
        <Button variant="default" size="lg" className="text-base text-white" asChild>
          <Link href={FORM_REGISTER_URL} target="_blank" rel="noopener noreferrer">
            {text.MAIN.INTRODUCTION.HEADING_4}
          </Link>
        </Button>
      )}
    </div>
  )
}
